import React, { useDebugValue } from "react";
import { useEffect, useCallback, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Dropdown,
  Modal,
  NavDropdown,
  Offcanvas,
  OverlayTrigger,
  Row,
  Tab,
  Tabs,
  Tooltip,
  useAccordionButton,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import ReactDOMServer from "react-dom/server";
import {
  MapContainer,
  TileLayer,
  Popup,
  Marker,
  LayersControl,
  GeoJSON,
  useMapEvent,
} from "react-leaflet";
import "leaflet/dist/leaflet.css"; // Don't forget to import the Leaflet CSS
import axios from "axios";
import "../operation/Displays.css";
import * as L from "leaflet";
import * as turf from "@turf/turf";
///Service
import ForeCast from "../../../services/forecast.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
//// Date-related
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

//// Icon
import {
  FaBarsStaggered,
  FaEraser,
  FaRegEye,
  FaRegEyeSlash,
} from "react-icons/fa6";
import { CiNoWaitingSign, CiSearch } from "react-icons/ci";
import { GoLocation } from "react-icons/go";
import { Icon, stepConnectorClasses } from "@mui/material";
import {
  Check,
  ContactSupportOutlined,
  FilterDrama,
  Maximize,
} from "@mui/icons-material";
import { MdOutlineKeyboardDoubleArrowUp, MdDoubleArrow } from "react-icons/md";

import { IoCloseOutline } from "react-icons/io5";

////Component
import ForeCast_Elem from "../etc/ForeCast_Elem";

//// Data
///Dummy_Data_Weather

//import dataDummy from "../operation/DummyArea.json";
import hospitalArea from "../operation/hospitalLocation.json";
import province from "../operation/gadm41_THA_2.json";
import { geometry } from "@turf/turf";
import {
  cleanDigitSectionValue,
  cleanString,
} from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";
import { filter } from "jszip";
import { Field } from "formik";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { number } from "yup";
import { Navigate, json, useNavigate } from "react-router-dom";
import Control from "react-leaflet-custom-control";
import Static_modal from "../etc/Static_modal";
const OperationDisplays = () => {
  // main
  let Navigate = useNavigate();
  //Map and Func
  // [13.1008, 100.9305]
  const [position, setPosition] = useState([13.1008, 100.9305]);
  const [map, setMap] = useState(null);
  const [markerDescription, setMarkerDesciption] = useState(
    `Position : ${position[0]}, ${position[1]} (Latitude, Longitude)`
  );

  ///handle
  const [sidebarMain, setSidebarMain] = useState(false);
  const [show, setShow] = useState(false);
  const [showRemarks, setShowRemarks] = useState({
    ShowRemark1: false,
    ShowRemark2: false,
    ShowRemark3: false,
    ShowRemarkPlan: false,
    ShowRemarkNearPlan: false,
    DataFocus: "",
  });
  const [remarkData, setRemarkData] = useState({
    remarks: "",
    upperLimit: "",
    lowerLimit: "",
  });
  const [userName, setUserName] = useState("");

  const [focusingPolygon, setFocusingPolygon] = useState(null);

  const handleClose = () =>
    setShow(false) ||
    setShowRemarks({
      ShowRemark1: false,
      ShowRemark2: false,
      ShowRemark3: false,
      ShowRemarkPlan: false,
      ShowRemarkNearPlan: false,
    });
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
  };

  const handleShow = () => setShow(true);

  const RemarkDetails = ({ data, datatype }) => {
    if (
      data.remarks !== undefined &&
      data.lowerLimit !== undefined &&
      data.upperLimit !== undefined &&
      datatype === "remarkdata"
    ) {
      return (
        <div className="sidebox-remark" style={{ top: "300px" }}>
          <div className="remark-details">
            <div style={{ textAlign: "center" }}>
              <strong>{showRemarks.DataFocus}</strong>
              <i className="icon-edit" style={{ float: "right" }}>
                <IoCloseOutline
                  style={{ width: "30px", height: "30px" }}
                  onClick={() => {
                    setShowRemarks(false);
                  }}
                />
              </i>
            </div>
            <div>
              <strong>Type of restriction:</strong>{" "}
              {data.remarks["Type of restriction"]}
            </div>
            <div>
              <strong>Nature of hazard, activity:</strong>{" "}
              {data.remarks["Nature of hazard, activity"]}
            </div>
            <div>
              <strong>Time of activity:</strong>{" "}
              {data.remarks["Time of activity"]}
            </div>
            <div>
              <strong>Permission to entry:</strong>{" "}
              {data.remarks["Permission to entry"]}
            </div>
            <div>
              <strong>Inflight information:</strong>{" "}
              {data.remarks["Inflight information"]}
            </div>
            <div>
              <strong>Contact agency:</strong> {data.remarks["Contact agency"]}
            </div>
            <div>
              <strong>Tel :</strong> {data.remarks["Tel"]}
            </div>
            <div>
              <strong>UpperLimit :</strong> {data.upperLimit}
            </div>
            <div>
              <strong>Lower_limit :</strong> {data.lowerLimit}
            </div>
          </div>
        </div>
      );
    } else if (data !== undefined && datatype === "operator_data") {
      return (
        <div className="sidebox-remark" style={{ top: "300px" }}>
          <div className="remark-details" style={{ width: "100%" }}>
            <div style={{ textAlign: "center" }}>
              <strong>{showRemarks.DataFocus}</strong>
              <i className="icon-edit" style={{ float: "right" }}>
                <IoCloseOutline
                  style={{ width: "30px", height: "30px" }}
                  onClick={() => {
                    setShowRemarks(false);
                  }}
                />
              </i>
            </div>
            <div>
              <strong>นักบิน :</strong>{" "}
              {data.pilot_name === undefined ? null : data.pilot_name}
            </div>
            <div>
              <strong>ชื่อปฏิบัติการ :</strong>{" "}
              {data.name === undefined ? null : data.name}
            </div>
            <div>
              <strong>ถูกสร้างเมือ :</strong>{" "}
              {data.create_at === undefined ? null : data.create_at}
            </div>
            <div>
              <strong>เวลาเริ่มต้น :</strong>{" "}
              {data.start_time === undefined ? null : data.start_time}
            </div>
            <div>
              <strong>เวลาสิ้นสุด :</strong>{" "}
              {data.end_time === undefined ? null : data.end_time}
            </div>
            <div>
              <strong>เวลาสิ้นสุด :</strong>{" "}
              {data.status === undefined ? null : data.status}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  ///Icon state
  const [iconeye1, setIconEye1] = useState(true);
  const [iconeye2, setIconEye2] = useState(true);
  const [iconeye3, setIconEye3] = useState(true);

  ///PolygonLeaflet
  const [thailandProvince, setThailandProvince] = useState();
  const [PDRArea, setPDRArea] = useState(undefined);
  const [ProhibitedAreas, setProhibitedAres] = useState(undefined);
  const [RestrictedAreas, setRestrictedAreas] = useState(undefined);
  const [DangerAres, setDangerAres] = useState(undefined);
  const [Aerodrome, setAeroDrome] = useState(undefined);
  const [hospital, setHospital] = useState(undefined);
  const [govOffice, setGovOffice] = useState(undefined);
  const [thaiGov, setThaiGov] = useState(undefined);
  const [embassy, setEmbassy] = useState(undefined);
  const [policeDepartment, setPoliceDepartment] = useState(undefined);
  const [prohibitPolygon, setProhibitPolygon] = useState(undefined);
  const [showErroroperation, setShowErroroperation] = useState(false);

  ///Form variable
  const [displayplans, setDisplayplans] = useState(1);
  const [researchArea, setResearchArea] = useState([position[1], position[0]]);
  const [dimensionArea, setDimensionArea] = useState(1);
  const [bboxGeoJson, setBboxGeoJson] = useState(undefined);
  const [start_time, setStart_time] = useState("");
  const [end_time, setEnd_time] = useState("");
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");

  //// เอาไปใช้ได้กับตอนรับข้อมูลมาเป็น ชุดข้อมูล  lon , lat แล้วจะทำเป็นฟอแมต Geojson นะจ๊ะ
  const Convert_resData_ToGeoJson = (dataset) => {
    let AllFeature = [];
    dataset.map((feature) => {
      console.log("Logging Feature :", feature);
      let stdCoordinates = [];
      feature.area_new_format.forEach(({ Lon, Lat }) => {
        stdCoordinates.push([Lon, Lat]);
      });
      let Feature = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [stdCoordinates],
        },
        properties: {
          operation_id: `${feature.operation_id}`,
          operation_operator: `${feature.operator_name}`,
          operation_status: `${feature.operation_status}`,
        },
      };
      AllFeature.push(Feature);
    });
    let GeoJson = {
      type: "FeatureCollection",
      features: AllFeature,
    };
    return GeoJson;
  };

  const SelectSquarePosition = (DimensionSQ, lat, lng) => {
    setPosition([lat, lng]);
    setMarkerDesciption(
      `Position : ${lat.toFixed(5)}, ${lng.toFixed(5)} (Latitude, Longitude)`
    );
    let centerPoint = turf.point([lng, lat]);

    //สร้างเส้นทะแยงมุม /// Succccc ///  Ex. Radius ที่เข้ามา = 7 เส้นผ่าศูนย์กลางจะได้ 14 ดังนั้นถ้าต้องการ เส้นผ่าศูนย์กลาง  = 7 ต้องนำ Rad/2

    const radius = DimensionSQ;
    const diagonalLine = turf.lineString([
      turf.destination(centerPoint, radius, 45).geometry.coordinates,
      turf.destination(centerPoint, radius, 135).geometry.coordinates,
      turf.destination(centerPoint, radius, 225).geometry.coordinates,
      turf.destination(centerPoint, radius, 315).geometry.coordinates,
    ]);
    //(diagonalLine);
    const boundingPolygon = turf.polygon([
      [
        diagonalLine.geometry.coordinates[0],
        diagonalLine.geometry.coordinates[1],
        diagonalLine.geometry.coordinates[2],
        diagonalLine.geometry.coordinates[3],
        diagonalLine.geometry.coordinates[0],
      ],
    ]);

    let settingproperties2 = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: boundingPolygon.geometry.coordinates,
          },
          properties: {
            name: `พื้นที่สำหรับการค้นหา แผนการบิน ${dimensionArea} Km.`,
          },
        },
      ],
    };
    clearMap("Select-Square2");
    L.geoJSON(settingproperties2, {
      style: function (feature) {
        return { color: "green", fillOpacity: 0, zIndex: -99 };
      },
      id: "Select-Square2",
    })
      .bindPopup(function (layer) {
        return layer.feature.properties.name;
      })
      .addTo(map);
    clearMap("Select-Square");

    // let circle = turf.circle(centerPoint, DimensionSQ, {
    //   steps: 64,
    //   units: "kilometers",
    // });
    //let square = turf.bboxPolygon(turf.bbox(circle));
    // let settingproperties = {
    //   type: "FeatureCollection",
    //   features: [
    //     {
    //       type: "Feature",
    //       geometry: {
    //         type: "Polygon",
    //         coordinates: circle.geometry.coordinates,
    //       },
    //       properties: {
    //         name: `พื้นที่สำหรับการค้นหา แผนการบิน ${dimensionArea} Km.`,
    //       },
    //     },
    //   ],
    // };
    // clearMap("Select-Circle");
    // L.geoJSON(settingproperties, {
    //   style: function (feature) {
    //     return { color: "green" };
    //   },
    //   id: "Select-Circle",
    // })
    //   .bindPopup(function (layer) {
    //     return layer.feature.properties.name;
    //   })
    //   .addTo(map);

    CheckIntersection(settingproperties2);
    //(boundingPolygon);
    let s_time = formattingDate(new Date(start_date), new Date(start_time));
    let e_time = formattingDate(new Date(end_date), new Date(end_time));
    let s_coord = `${
      (diagonalLine.geometry.coordinates[0],
      diagonalLine.geometry.coordinates[0])
    }`;
    let e_coord = `${
      (diagonalLine.geometry.coordinates[2],
      diagonalLine.geometry.coordinates[2])
    }`;

    AuthServiceV2.AreaSpecificTime(s_time, e_time, s_coord, e_coord)
      .then((res) => {
        if (res.data.status === "success") {
          if (res.data.data.length !== 0) {
            setIntersection_Near_Plan(undefined);
            const returnedData = res.data.data;
            let GeoJsonData = Convert_resData_ToGeoJson(res.data.data);
            setIntersection_Near_Plan(GeoJsonData);
          } else {
            setIntersection_Near_Plan(undefined);
          }
        } else {
          alert("Data Not found : " + res.data.error_description);
        }
      })
      .catch((err) => {
        console.log(err, err.data);
        alert("เกิดข้อผิดพลาดการดึงข้อมูลพื้นที่ ที่คุณเลือก");
      });
    setDisplayplans(2);
    setSidebarMain(true);
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties && feature.properties.operation_id) {
      layer.bindPopup(`<h5>หมายเลขปฏิบัติการ ${feature.properties.operation_id}</h5>
                    <h6>พื้นที่ของคุณ ${feature.properties.operation_operator}</h6>`);
    }
    // else if (feature.properties && feature.properties.Ministry) {
    //   layer.bindPopup(feature.properties.Agency);
    // } else if (feature.properties && feature.properties.name_t) {
    //   layer.bindPopup(feature.properties.name_t);
    // }
  };

  const clearMap = (leafletId) => {
    map.eachLayer(function (layer) {
      if (layer.options && layer.options.id === leafletId) {
        map.removeLayer(layer);
      }
    });
  };

  ///Search
  const [onlySearchArea, setOnlySearchArea] = useState();
  const [searchvalue, setSearchValue] = useState();
  const [activeItem, setActiveItem] = useState(null);
  const SearchLocation = (search) => {
    ///Format  Check DMS,Lat-Long,String,
    if (search !== undefined && search !== "") {
      setFilterSearchValue([]);
      let coordinates = search.split(" ");
      const stdData = search.split(/\s+|,+/);
      const searchString = stdData.join(" ");

      if (
        !isNaN(parseFloat(coordinates[0])) ||
        !isNaN(parseFloat(coordinates[1]))
      ) {
        ///Check DMS
        const splitspace = searchString.split(" ");
        const convertString = splitspace.join("");
        const coordinateRegex =
          /^(\d{1,2})°(\d{1,2})'([\d.]+)(''|")\s*([NS])\s*(\d{1,3})°\s*(\d{1,2})'\s*([\d.]+)(''|")\s*([EW])$/; ///ดึงจาก Google Map ตัวหนังสือจะติดกัน
        const coordinateRegex1 =
          /^(\s*\d{1,2})°\s(\d{1,2})'\s([\d.]+)(''|")\s*([NS])\s*,?\s*(\d{1,3})°\s(\d{1,2})'\s([\d.]+)(''|")\s*([EW])$/; ///ดึงจากเว็บแปลงตัวหนังสือห่าง
        const matchDMS =
          convertString.match(coordinateRegex1) ||
          convertString.match(coordinateRegex); //ถ้า = null ไม่ใช่ DMS
        ///Check coordinate
        const latRegex = /^\s*[-+]?(90(\.0+)?|[1-8]?\d(\.\d+)?)\s*$/;
        const lonRegex =
          /^\s*[-+]?((180(\.0+)?)|((1[0-7]\d|\d{1,2})(\.\d+)?))\s*$/;
        const [lat, long] = searchString.split(/\s+|,+/);
        const isLatValid = latRegex.test(lat);
        const isLongValid = lonRegex.test(long);
        if (matchDMS !== null) {
          const latDegrees = parseFloat(matchDMS[1]);
          const latMinutes = parseFloat(matchDMS[2]);
          const latSeconds = parseFloat(matchDMS[3]);
          const latDirection = matchDMS[5];

          const lonDegrees = parseFloat(matchDMS[6]);
          const lonMinutes = parseFloat(matchDMS[7]);
          const lonSeconds = parseFloat(matchDMS[8]);
          const lonDirection = matchDMS[10];

          if (
            latDegrees >= 0 &&
            latDegrees <= 90 &&
            latMinutes >= 0 &&
            latMinutes < 60 &&
            latSeconds >= 0 &&
            latSeconds < 60 &&
            (latDirection === "N" || latDirection === "S")
          ) {
            if (
              lonDegrees >= 0 &&
              lonDegrees <= 180 &&
              lonMinutes >= 0 &&
              lonMinutes < 60 &&
              lonSeconds >= 0 &&
              lonSeconds < 60 &&
              (lonDirection === "E" || lonDirection === "W")
            ) {
              const latitude =
                latDirection === "N"
                  ? latDegrees + latMinutes / 60 + latSeconds / 3600
                  : -(latDegrees + latMinutes / 60 + latSeconds / 3600);
              const longitude =
                lonDirection === "E"
                  ? lonDegrees + lonMinutes / 60 + lonSeconds / 3600
                  : -(lonDegrees + lonMinutes / 60 + lonSeconds / 3600);
              setPosition([latitude, longitude]);
              map.flyTo([latitude, longitude], 12);
              setSearchValue(convertString);
            }
          }
        } else if (isLatValid && isLongValid) {
          setPosition([lat, long]);
          map.flyTo([lat, long], 18);
          setSearchValue(lat + "," + long);
        } else {
          alert("ไม่พบข้อมูลสถานที่");
        }
      } else {
        if (search[0] !== " ") {
          const filteredData1 = province.features.filter((item) => {
            const searchTerm = search.toLowerCase();
            return (
              item.properties.NAME_1?.toLowerCase().includes(searchTerm) ||
              item.properties.NAME_2?.toLowerCase().includes(searchTerm) ||
              item.properties.NL_NAME_1?.toLowerCase().includes(searchTerm) ||
              item.properties.NL_NAME_2?.toLowerCase().includes(searchTerm)
            );
          });

          const filteredData2 = PDRArea.features.filter((item) => {
            const searchTerm = search.toLowerCase();
            return item.properties.name?.toLowerCase().includes(searchTerm);
          });

          const filteredData = [...filteredData1, ...filteredData2];

          if (filteredData.length !== 0) {
            setMarkerDesciption(
              filteredData[0].properties.NL_NAME_2 +
                " " +
                filteredData[0].properties.NL_NAME_1
            );
            let centroid = turf.centroid(filteredData[0]);
            setPosition([
              centroid.geometry.coordinates[1],
              centroid.geometry.coordinates[0],
            ]);
            map.setView(
              [
                centroid.geometry.coordinates[1],
                centroid.geometry.coordinates[0],
              ],
              12
            );
            clearMap("SearchLayer");
            L.geoJSON(filteredData, {
              style: function (feature) {
                return { color: feature.properties.color };
              },
              id: "SearchLayer",
            })
              .bindPopup(function (layer) {
                if (layer.feature.properties.name !== undefined) {
                  return layer.feature.properties.name;
                } else if (layer.feature.properties.NL_NAME_1 !== undefined) {
                  return layer.feature.properties.NL_NAME_1;
                } else {
                  return "ไม่ทราบข้อมูล";
                }
              })
              .addTo(map);
            //CheckIntersection(filteredData);
          } else {
            alert("ไม่พบจ่ะ");
          }
        } else {
          alert("ไม่พบจ่ะ");
        }
      }
    } else {
      alert("ไม่พบข้อมูลที่ค้นหาจ่ะ");
    }
  };
  const handleItemClick = (item) => {
    setSearchValue(item.properties.NL_NAME_2);
    SearchLocation(item.properties.NL_NAME_2);
  };
  const showMyLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (map) {
            setPosition([position.coords.latitude, position.coords.longitude]);
            map.setView(
              [position.coords.latitude, position.coords.longitude],
              14,
              {
                animate: true,
              }
            );
          } else {
            setPosition([position.coords.latitude, position.coords.longitude]);
            map.setView(
              [position.coords.latitude, position.coords.longitude],
              14,
              {
                animate: true,
              }
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      setPosition([position.coords.latitude, position.coords.longitude]);
      map.current.flyTo([13.102617437258145, 100.88806223049966], 15, {
        animate: true,
        setPosition,
      });
    }
  };

  function DisplayPosition({ map }) {
    let [positions, setPositions] = useState(() => map.getCenter());
    const onClick = useCallback(() => {
      map.flyTo(position, 14);
    }, [map]);

    const onMove = useCallback(() => {
      setPositions(map.getCenter());
      setResearchArea([positions.lng, positions.lat]);
    }, [map]);

    useEffect(() => {
      map.on("move", onMove);
      return () => {
        map.off("move", onMove);
      };
    }, [map, onMove]);

    return (
      <p style={{ fontSize: "14px" }}>
        latitude: {positions.lat.toFixed(4)}, longitude:{" "}
        {positions.lng.toFixed(4)}
        <button
          style={{
            marginLeft: "5px",
            zIndex: 2,
            border: "none",
            opacity: "1px",
            backgroundColor: "rgb(255, 255, 255, 0.3)",
          }}
          onClick={() => {
            showMyLocation();
          }}
        >
          <GoLocation />
        </button>
      </p>
    );
  }

  useEffect(() => {
    const data1 = AuthServiceV2.getCurrentUser()
      .then((result) => {
        setUserName(`${result.data.data.f_name} ${result.data.data.l_name}`);
      })
      .catch((error) => {
        setTextBody(error);
        setModalToggle({ ...modalToggle, modalErr: true });
      });
  }, []);

  ///scroll Effect
  const [scrollPosition, setScrollPosition] = useState(window.scrollY);
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [filterSearchValue, setFilterSearchValue] = useState([]);
  ////filtersearchValue
  useEffect(() => {
    if (searchvalue !== undefined && searchvalue !== "") {
      const filteredData = province.features.filter((item) => {
        return (
          item.properties.NAME_1?.toLowerCase().includes(
            searchvalue.toLowerCase()
          ) ||
          item.properties.NAME_2?.toLowerCase().includes(
            searchvalue.toLowerCase()
          ) ||
          item.properties.NL_NAME_1?.toLowerCase().includes(
            searchvalue.toLowerCase()
          ) ||
          item.properties.NL_NAME_2?.toLowerCase().includes(
            searchvalue.toLowerCase()
          )
        );
      });
      setFilterSearchValue(filteredData);
    }
  }, [searchvalue]);

  ///Data From PolygonLeafletCheckIntersection
  useEffect(() => {
    async function fetchData() {
      try {
        const { data: thailandData } = await axios.get(
          "https://raw.githubusercontent.com/apisit/thailand.json/master/thailandwithdensity.json"
        );
        setThailandProvince(thailandData);
        const [
          responsePDRArea,
          responseAeroDrome,
          responseHospital,
          responseGovOffice,
          responseEmbassy,
          responsePoliceDepartment,
          responseThaiGov,
          allGeoData,
        ] = await Promise.all([
          axios.get("../../PDR-AREA.geojson"),
          axios.get("../../Aerodrome.geojson"),
          axios.get("../../hospitalLocation.geojson"),
          axios.get("../../GovOfficetoutput.geojson"),
          axios.get("../../Embassyoutput.geojson"),
          axios.get("../../PoliceDepartmentoutput.geojson"),
          axios.get("../../ThaiGovoutput.geojson"),
          AuthServiceV2.AllGeoFenceData().then((res) => {
            return res;
          }),
        ]);
        let PDRDataset = {
          type: "FeatureCollection",
          features: [
            ...allGeoData.data.prohibited_areas.features,
            ...allGeoData.data.danger_areas.features,
            ...allGeoData.data.restricted_areas.features,
          ],
        };
        setProhibitedAres(allGeoData.data.prohibited_areas.features);
        setRestrictedAreas(allGeoData.data.restricted_areas.features);
        setDangerAres(allGeoData.data.danger_areas.features);
        setPDRArea(PDRDataset);
        setAeroDrome(allGeoData.data.aerodrome.features);
        setHospital(responseHospital.data);
        setGovOffice(responseGovOffice.data);
        setThaiGov(responseThaiGov.data);
        setPoliceDepartment(responsePoliceDepartment.data);
        setEmbassy(responseEmbassy.data);
        ////(responseEmbassy.data);
        // //("responseEmbassy", responseEmbassy.data);
        const ProhibiGeo = {
          type: "FeatureCollection",
          features: [
            //...responsePDRArea.data.features,
            ...allGeoData.data.aerodrome.features,
            ...allGeoData.data.danger_areas.features,
            ...allGeoData.data.other_areas.features,
            ...allGeoData.data.prohibited_areas.features,
            ...allGeoData.data.restricted_areas.features,
            ...responseHospital.data.features,
            ...responseGovOffice.data.features,
            ...responseEmbassy.data.features,
            ...responsePoliceDepartment.data.features,
            ...responseThaiGov.data.features,
          ],
        };
        ////(ProhibiGeo);
        setProhibitPolygon(ProhibiGeo);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    }
    fetchData();
    GetMyLocation();
    //getOperationAreaData()
  }, [searchvalue]);

  const [intersection_Near_Plan, setIntersection_Near_Plan] =
    useState(undefined);
  const [intersection_ProhibitedAreas, setIntersection_ProhibitedAreas] =
    useState([]);
  const [intersection_RestrictedAreas, setIntersection_RestrictedAreas] =
    useState([]);
  const [intersection_Danger, setIntersection_Danger] = useState([]);
  const [intersection_All, setIntersection_All] = useState([]);
  function CheckIntersection(mainFeature) {
    if (!mainFeature) {
    } else {
      let intersection_store_Restri = [];
      let intersection_store_Prohi = [];
      let intersection_store_Danger = [];
      let intersection_store_all = [];
      // //(prohibitPolygon);
      // //(mainFeature);
      prohibitPolygon.features.map((feature) => {
        let check = turf.booleanIntersects(mainFeature, feature);
        if (check) {
          intersection_store_all.push(feature);
        }
      });
      setIntersection_ProhibitedAreas(intersection_store_Prohi);
      setIntersection_RestrictedAreas(intersection_store_Restri);
      setIntersection_Danger(intersection_store_Danger);
      setIntersection_All(intersection_store_all);
    }
  }

  function CheckdimensionData(multipolygon) {
    const size = turf.area(multipolygon);
    if (0 <= size && size <= 30000) {
      return 16;
    } else if (30000 < size && size <= 10000000) {
      return 14;
    } else if (10000000 < size && size <= 1000000000) {
      return 12;
    } else {
      return 10;
    }
  }
  function MoveToCenterPolygon(multipolygon) {
    setFocusingPolygon(multipolygon);
    clearMap("MoveTo-center");
    let centroid = turf.centroid(multipolygon);
    const viewsize = CheckdimensionData(multipolygon);
    ////(viewsize);
    let geojsonLayer = L.geoJSON(multipolygon, {
      style: function (feature) {
        return { color: "black", opacity: "1" };
      },
      id: "MoveTo-center",
      onEachFeature: function (feature, layer) {
        if (feature.properties.operation_id === undefined) {
          const propertiesOfItem = feature.properties;
          const areaName = () => {
            console.log(propertiesOfItem);
            if (propertiesOfItem.name) {
              return `<p>ชื่อสถานที่ : ${propertiesOfItem.name}</p>`;
            }
            if (propertiesOfItem.Agency) {
              return `<p>ชื่อสถานที่ : ${propertiesOfItem.Agency}</p>`;
            }
            if (propertiesOfItem.name_t) {
              return `<p>ชื่อสถานที่ : ${propertiesOfItem.name_t}</p>`;
            }
            return `<div></div>`;
          };
          const areaAddress = () => {
            if (propertiesOfItem.province) {
              return `<p>ตำแหน่ง : ${propertiesOfItem.province}</p>`;
            }
            if (propertiesOfItem.address) {
              return `<p>ตำแหน่ง : ${propertiesOfItem.address}</p>`;
            }
            if (propertiesOfItem.Address) {
              return `<p>ตำแหน่ง : ${propertiesOfItem.Address}</p>`;
            }
            return `<div></div>`;
          };
          const areaTelephone = () => {
            if (propertiesOfItem.remarks) {
              if (propertiesOfItem.remarks.Tel) {
                return `<p>โทรศัพท์ : ${propertiesOfItem.remarks.Tel}</p>`;
              }
            } else {
              if (propertiesOfItem.tel) {
                return `<p>โทรศัพท์ : ${propertiesOfItem.tel}</p>`;
              }
              return `<div></div>`;
            }
          };

          const areaTypeOfRestriction = () => {
            if (propertiesOfItem.remarks) {
              if (propertiesOfItem.remarks["Type of restriction"]) {
                return `<p>ประเภทสถานที่ : ${propertiesOfItem.remarks["Type of restriction"]}</p>`;
              }
            } else {
              return "<div></div>";
            }
          };

          // console.log(areaName())
          // const areaName =
          // feature.properties.name !== undefined ? feature.properties.name : feature.properties.Agency

          layer.bindPopup(
            `${areaName()}         
            ${areaTypeOfRestriction()}          
            ${areaAddress()}           
            ${areaTelephone()}`
          );
          // <h5>Contact agency:${feature.properties.remarks["Contact agency"]}</h5>
          //         <h6>Inflight information:${feature.properties.remarks["Inflight information"]}</h6>`);
        } else {
          layer.bindPopup(
            `<h5>หมายเลขปฏิบัติการ ${feature.properties.operation_id}</h5>
                    <h6>พื้นที่ของคุณ ${feature.properties.operation_operator}</h6>`
          );
        }
      },
    });

    geojsonLayer.addTo(map);
    map.setView(
      [centroid.geometry.coordinates[1], centroid.geometry.coordinates[0]],
      viewsize
    );
    geojsonLayer.eachLayer(function (layer) {
      if (layer.getPopup()) {
        layer.openPopup();
        return; // Exit after opening the first popup
      }
    });
  }

  const popupRef = React.useRef(null);
  //RightClickMenu component
  function RightClickMenu(lat, lng) {
    // if (focusingPolygon != null) {
    //   let geojsonLayer = L.geoJSON(focusingPolygon, {
       
    //   });
    //   geojsonLayer.resetStyle()
    //   setFocusingPolygon(null);
    // }
    const popupContent = `
    <div>
    <p id="latlonSelect" style="cursor:"pointer"> ${lat.toFixed(
      5
    )},${lng.toFixed(5)}</p>
    <button onclick="noobClick(${dimensionArea},${lat},${lng})">เช็คพื้นที่ ระยะ ${dimensionArea} km.</button>
    
    </div>`;
    return popupContent;
  }
  const [showPopup, setShowpopup] = useState(false);
  // Main RightClick Menu
  const handleContextMenu = (event) => {
    const { latlng } = event;
    const { lat, lng } = latlng;
    ////(latlng);
    const newPopup = L.popup({ offset: [90, 100], closeButton: false })
      .setLatLng(latlng)
      .setContent(RightClickMenu(lat, lng))
      .openOn(map);

    popupRef.current = newPopup;
    setShowpopup(true);
    ////(popupRef.current);
    window.noobClick = (dimensionArea, lat, lng) => {
      if (
        dimensionArea > 7 ||
        typeof lat !== "number" ||
        typeof lng !== "number"
      ) {
        return null;
      } else {
        SelectSquarePosition(dimensionArea, lat, lng);
        // Todo ทำเซ็ตหมุด สำหรับ Weather forecast
      }
    };
  };
  const MapEvents = () => {
    useMapEvent("contextmenu", handleContextMenu);
    return null;
  };

  /// Dataset wait for send to Backend
  function formattingDate(inputDate, start_time) {
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");

    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = start_time.getHours().toString().padStart(2, "0");
    const minutes = start_time.getMinutes().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:00+07:00`;

    return formattedDate;
  }
  // function formattingDate(datetime) {
  //   const formattedDate = `${datetime.$y}-${
  //     datetime.$M < 10 ? "0" + (datetime.$M + 1) : datetime.$M + 1
  //   }-${datetime.$D < 10 ? "0" + datetime.$D : datetime.$D}T${
  //     datetime.$H < 10 ? "0" + datetime.$H : datetime.$H
  //   }:${datetime.$m<10? "0"+datetime.$m:datetime.$m}:00+07:00`;

  //   return formattedDate;
  // }
  const getDate_Time = (param) => {
    const currentDateTime = dayjs();
    if (param === "today") {
      ///todaye Date
      const todayDate = dayjs(currentDateTime.format("YYYY-MM-DD"));
      setStart_date(todayDate);
      setEnd_date(todayDate);
    } else if (param === "3Hours") {
      ///today Time
      const currentStart_Time = currentDateTime;
      const currentEnd_time = currentDateTime.add(3, "hours");
      // //(currentStart_Time);
      // //(currentEnd_time);
      setStart_time(currentStart_Time);
      setEnd_time(currentEnd_time);
      ////(currentStart_Time, currentEnd_time);
    } else {
      alert("มั่ว");
    }
  };

  const [itemsA, setItemsA] = useState([]);
  //// Test fetch operation data

  /// Get plan ถ้ามี แผนการบิน
  const [myplan, setMyplan] = useState([]);
  const [operator_Area_Checked, setOperator_Area_Checked] = useState(true);
  const [operator_Area, setOperator_Area] = useState(undefined);
  const [operator_Displays, setOperator_Displays] = useState(undefined);
  const [agency_Ares, setAgency_Ares] = useState(undefined);
  const [agency_Displays, setAgency_Displays] = useState(undefined);
  const [displayMyplan, setDisplayMyplan] = useState(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        let operatorid = await sessionStorage.getItem("operator_id");
        //(operatorid);
        if (operatorid !== "null" && operatorid !== undefined) {
          let response = await AuthServiceV2.Opearationdata();
          if (response.data.agency_data) {
            //("no data agency");
            //////ยังไม่รู้จัดเขียนอะไรยังไง
          }
          if (response.data.operator_data) {
            if (response.data.operator_data.length !== 0) {
              let createfeature = [];
              let createfeature_approve = [];
              response.data.operator_data.map((feature) => {
                let stdCoordinates = [];
                feature.operation_area.Volume3D.outline_polygon.vertices.forEach(
                  ({ Lon, Lat }) => {
                    stdCoordinates.push([Lon, Lat]);
                  }
                );
                let GeoformatPush = {
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [stdCoordinates],
                  },
                  properties: {
                    name: feature.id,
                    start_time: feature.start_time,
                    end_time: feature.end_time,
                    timestamp: feature.timestamp,
                    create_at: feature.create_at,
                    updated_at: feature.updated_at,
                    status: feature.operation_status,
                    pilot_name: feature.pilot_name,
                  },
                };

                if (feature.operation_status === "อนุมัติ") {
                  createfeature_approve.push(GeoformatPush);
                  createfeature.push(GeoformatPush);
                } else {
                  createfeature.push(GeoformatPush);
                }
              });

              ////////////////////
              let createGeojson = {
                type: "FeatureCollection",
                features: createfeature,
              };
              let createGeoJsonAprrove = {
                type: "FeatureCollection",
                features: createfeature_approve,
              };
              let createGeoJsonETC = {
                type: "FeatureCollection",
                features: createfeature_approve,
              };
              setOperator_Displays(createGeojson);
              if (createGeoJsonAprrove.features.length !== 0) {
                setOperator_Area(createGeoJsonAprrove);
              } else {
                setOperator_Area(undefined);
              }
            } else {
              setOperator_Displays(undefined);
              setOperator_Area(undefined);
            }
          } else {
            alert("ไม่พบข้อมูลแผนการบินของคุณ");
          }
        } else {
          setDisplayMyplan(undefined);
        }
      } catch (error) {
        alert("Error fetching data:", error);
      }
    };

    fetchData(); // Invoke the fetchData function
  }, []);

  ///ForeCast_Weather
  const [mylocation, setMyLocation] = useState(undefined);
  const [forcast_data, setForeCast_Data] = useState(undefined);
  const [forecast_active, setForeCast_Active] = useState(false);
  const handle_Forecast = (isActive) => {
    setForeCast_Active(isActive);
  };

  async function Forecast_Fetch(latlng, days) {
    await ForeCast.Forecast(latlng, days)
      .then((res) => {
        setForeCast_Data(res.data);
      })
      .catch((err) => {
        console.log(err, err.message);
        if (err.message === "Network Error") {
          alert("Service Didn't Work"); // Network Error
        } else {
          if (err.response.data.error === "Parameter q is missing.") {
            alert("ระบุ lat,lng ให่้ถูกต้อง");
          }
        }
      });
  }
  function GetMyLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (map) {
            setMyLocation(
              `${position.coords.latitude},${position.coords.longitude}`
            );
          } else {
            setMyLocation(
              `${position.coords.latitude},${position.coords.longitude}`
            );
          }
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      return setMyLocation("13.102617437258145, 100.88806223049966");
    }
  }
  useEffect(() => {
    if (position !== undefined) {
      let myposition = position.join(",");
      Forecast_Fetch(myposition, 7);
    }
  }, [position]);

  //รอบล็อค
  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");
    if (operatorid === "null" || operatorid === undefined) {
      setShowErroroperation(true);
      setTimeout(() => {
        setShowErroroperation(false);
        Navigate("/user/drone/statusDrone");
      }, 2000);
    } else {
      const check = AuthServiceV2.NewToken();
    }
  };
  useEffect(() => {
    setSidebarMain(true);
    checkoperator();
  }, []);

  return (
    <>
      <div
        style={{
          minHeight: "93.25vh",
          height: "auto",
          width: "auto",
          display: "flex",
        }}
      >
        <MapContainer
          id="map"
          center={position}
          zoom={10}
          style={{
            fontFamily: "Kanit",
            display: "relative",
            width: "100%",
            height: "auto",
            zIndex: 1,
          }}
          ref={setMap}
        >
          <MapEvents />

          <Marker position={position}>
            <Popup>{markerDescription}</Popup>
          </Marker>
          <Control position="topright">
            {/* displayPosition  */}
            <div className="refreshButton">
              {map ? <DisplayPosition map={map} /> : null}
            </div>
          </Control>
          {position[0] !== 0 && position[1] !== 0 ? (
            <Control prepend position="bottomright">
              <ForeCast_Elem
                ForeCast_Data={forcast_data}
                forecast_Active={forecast_active}
                getHandle={handle_Forecast}
              />
            </Control>
          ) : null}

          <LayersControl position="bottomright">
            <LayersControl.BaseLayer name="Google Map">
              <TileLayer
                style={{ zIndex: 400 }}
                url="http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer checked name="OpenStreet Map">
              <TileLayer
                style={{ zIndex: 400 }}
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenToPo Map">
              <TileLayer
                style={{ zIndex: 400 }}
                url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="ThunderForest Map">
              <TileLayer
                style={{ zIndex: 400 }}
                url="https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png"
              />
            </LayersControl.BaseLayer>
            <LayersControl.Overlay checked name="Aerodome area (orange)">
              {Aerodrome && (
                <GeoJSON
                  data={Aerodrome}
                  style={{
                    color: "orange",
                    fillColor: "orange",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            {/* <LayersControl.Overlay checked name="Flight prohibitation area (red)">
            {PDRArea && (
              <GeoJSON
                data={PDRArea}
                style={{
                  color: "red",
                  fillColor: "red",
                  fillOpacity: 0.5,
                }}
                onEachFeature={onEachFeature}
              />
            )}
          </LayersControl.Overlay> */}
            {/* <LayersControl.Overlay checked name="Hospital area (purple)">
            {hospital && (
              <GeoJSON
                data={hospital}
                style={{
                  color: "purple",
                  fillColor: "purple",
                  fillOpacity: 0.5,
                }}
                onEachFeature={onEachFeature}
              />
            )}
          </LayersControl.Overlay> */}
            <LayersControl.Overlay checked name="Goverment Office area (blue)">
              {govOffice && (
                <GeoJSON
                  data={govOffice}
                  style={{
                    color: "blue",
                    fillColor: "blue",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Embassy area (yellow)">
              {embassy && (
                <GeoJSON
                  data={embassy}
                  style={{
                    color: "yellow",
                    fillColor: "yellow",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay
              checked
              name="Police department area (green)"
            >
              {policeDepartment && (
                <GeoJSON
                  data={policeDepartment}
                  style={{
                    color: "green",
                    fillColor: "green",
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
            <LayersControl.Overlay checked name="Thai Goverment area (red)">
              {thaiGov && (
                <GeoJSON
                  data={thaiGov}
                  style={{
                    color: "red",
                    fillColor: "red",
                    fillOpacity: 1,
                  }}
                  onEachFeature={onEachFeature}
                />
              )}
            </LayersControl.Overlay>
          </LayersControl>
          {ProhibitedAreas && iconeye1 ? (
            <GeoJSON
              data={ProhibitedAreas}
              style={{
                color: "red",
                fillColor: "red",
                fillOpacity: 0.1,
                borderColor: "black",
              }}
              onEachFeature={onEachFeature}
            />
          ) : null}
          {RestrictedAreas && iconeye2 ? (
            <GeoJSON
              data={RestrictedAreas}
              style={{
                color: "red",
                fillColor: "red",
                fillOpacity: 0.1,
              }}
              onEachFeature={onEachFeature}
            />
          ) : null}
          {DangerAres && iconeye3 ? (
            <GeoJSON
              data={DangerAres}
              style={{
                color: "red",
                fillColor: "red",
                fillOpacity: 0.1,
              }}
              onEachFeature={onEachFeature}
            />
          ) : null}
          {operator_Area !== undefined ? (
            <GeoJSON
              data={operator_Area}
              style={{
                color: "blue",
                fillColor: "blue",
                fillOpacity: 0.2,
              }}
              onEachFeature={onEachFeature}
            />
          ) : null}
          {intersection_Near_Plan !== undefined ? (
            <GeoJSON
              data={intersection_Near_Plan}
              style={{
                color: "red",
                fillColor: "red",
                fillOpacity: 0.2,
              }}
              onEachFeature={onEachFeature}
            />
          ) : null}
        </MapContainer>
        {/* Search  */}
        {searchvalue === undefined || searchvalue === "" ? (
          <>
            <div className="search-location">
              <div
                className="icon-pointer"
                style={{
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <FaBarsStaggered style={{ width: "20px", height: "20px" }} />
              </div>

              <input
                className="search-input"
                type="text"
                placeholder="🔍 Search...."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />

              <div
                className="icon-pointer"
                style={{
                  marginLeft: "10px",
                }}
                onClick={() => SearchLocation(searchvalue)}
              >
                <CiSearch style={{ width: "20px", height: "20px" }} />
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className="search-location"
              style={{ borderRadius: "10px 10px 0px 0px" }}
            >
              <div
                className="icon-pointer"
                style={{
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <FaBarsStaggered style={{ width: "20px", height: "20px" }} />
              </div>
              <input
                className="search-input"
                type="text"
                placeholder="🔍 Search...."
                value={searchvalue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />

              <div
                className="icon-pointer"
                style={{
                  marginLeft: "10px",
                }}
                onClick={() => SearchLocation(searchvalue)}
              >
                <CiSearch style={{ width: "20px", height: "20px" }} />
              </div>
            </div>
            <div className="search-show-val">
              {filterSearchValue.slice(0, 5).map((item, index) => (
                <div
                  className={`searching-val ${
                    activeItem === index ? "active" : ""
                  }`}
                  value={item.properties.NL_NAME_2}
                  key={index}
                  onClick={() => handleItemClick(item)}
                  onFocus={() => setActiveItem(index)}
                  onBlur={() => setActiveItem(null)}
                  tabIndex="0"
                >
                  {item.properties.NL_NAME_1},{item.properties.NL_NAME_2}
                </div>
              ))}
            </div>
          </>
        )}
        {sidebarMain === true ? (
          <>
            <div
              className="sidebar-main"
              style={{
                position: "relative",
                top: "0px",
                height: "auto",
                animation: "none",
              }}
            >
              <Offcanvas.Header className="sidebar-header">
                <Offcanvas.Title>
                  <h3 style={{ marginTop: "15px" }}> สำรวจพื้นที่ทำการบิน</h3>
                </Offcanvas.Title>
              </Offcanvas.Header>

              <Tabs
                id="controlled-tabs"
                defaultActiveKey={displayplans}
                style={{
                  marginTop: "20px",
                  color: "#0077B6",
                  fontSize: "15px",
                }}
              >
                {/* <Tab
                  eventKey="1"
                  className="nav-link-test"
                  title={
                    <span
                      className="tabplan"
                      style={{
                        color: "#0077B6",
                        fontWeight: "500",
                      }}
                    >
                      แผนการบินของคุณ
                    </span>
                  }
                >
                  <Offcanvas.Body>
                    <div className="sidebar-wrapper">
                      <div className="sidebar-card">
                        <div
                          className="sidebar-card-body"
                          style={{ maxHeight: "300px" }}
                        >
                          <div
                            className="sidebar-card-title"
                            style={{ marginBottom: "15px", color: "#0077B6" }}
                          >
                            <h5 style={{ fontSize: "18px" }}>
                              แผนการบินกำลังดำเนินการ{" "}
                            </h5>
                          </div>
                          {operator_Area !== undefined ? (
                            operator_Area.features.map((feature) => {
                              return (
                                <p
                                  tabIndex={0}
                                  className="datafeatures"
                                  onClick={() => {
                                    MoveToCenterPolygon(feature);
                                    setShowRemarks(() => ({
                                      ShowRemarkPlan: true,
                                      DataFocus: feature.properties.name,
                                    }));
                                    setRemarkData(feature.properties);
                                  }}
                                >
                                  {feature.properties.name !== undefined ? (
                                    <p>{feature.properties.name}</p>
                                  ) : (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "center",
                                      }}
                                    >
                                      {" "}
                                      *** ไม่พบข้อมูลแผนการบินขอคุณ ***
                                    </p>
                                  )}
                                </p>
                              );
                            })
                          ) : (
                            <p style={{ color: "red", textAlign: "center" }}>
                              {" "}
                              *** ไม่พบข้อมูลแผนการบินที่กำลังทำการ ***
                            </p>
                          )}
                        </div>
                      </div>
                      {showRemarks.ShowRemarkPlan === true ? (
                        <RemarkDetails
                          data={remarkData}
                          datatype={"operator_data"}
                        />
                      ) : null}
                    </div>
                    <div className="sidebar-wrapper">
                      <div className="sidebar-card">
                        <div
                          className="sidebar-card-body"
                          style={{ maxHeight: "340px" }}
                        >
                          <div
                            className="sidebar-card-title"
                            style={{ marginBottom: "15px", color: "#0077B6" }}
                          >
                            <h5 style={{ fontSize: "18px" }}>
                              แผนการบินเสร็จสิ้นภารกิจ{" "}
                            </h5>
                          </div>
                          {operator_Displays !== undefined ? (
                            operator_Displays.features.map((feature) => {
                              return (
                                <p
                                  tabIndex={0}
                                  className="datafeatures"
                                  onClick={() => {
                                    MoveToCenterPolygon(feature);
                                    setShowRemarks(() => ({
                                      ShowRemarkPlan: true,
                                      DataFocus: feature.properties.name,
                                    }));
                                    setRemarkData(feature.properties);
                                  }}
                                >
                                  {feature.properties.name !== undefined ? (
                                    feature.properties.status ===
                                    "เสร็จภารกิจ" ? (
                                      <p>{feature.properties.name}</p>
                                    ) : null
                                  ) : (
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "center",
                                      }}
                                    >
                                      {" "}
                                      *** ไม่พบข้อมูลแผนการบินขอคุณ ***
                                    </p>
                                  )}
                                </p>
                              );
                            })
                          ) : (
                            <p style={{ color: "red", textAlign: "center" }}>
                              {" "}
                              *** ไม่พบข้อมูลแผนการบินที่กำลังทำการ ***
                            </p>
                          )}
                        </div>
                      </div>
                      {showRemarks.ShowRemarkPlan === true ? (
                        <RemarkDetails
                          data={remarkData}
                          datatype={"operator_data"}
                        />
                      ) : null}
                    </div>
                  </Offcanvas.Body>
                </Tab> */}
                <Tab
                  eventKey="1"
                  title={
                    <span
                      className="tabplan"
                      style={{
                        color: "#0077B6",
                        fontWeight: "500",
                        display: "flex",
                      }}
                    >
                      ตรวจสอบพื้นที่การบิน
                    </span>
                  }
                >
                  <Offcanvas.Body>
                    <div className="sidebar-wrapper">
                      <div className="sidebar-card">
                        <div
                          className="sidebar-card-title"
                          style={{ marginLeft: "2px" }}
                        >
                          <h5>ช่วงวันที่ต้องการสำรวจ</h5>
                        </div>
                        <div
                          className="sidebar-card-body"
                          style={{ overflow: "visible" }}
                        >
                          <div
                            className="selection-Date"
                            style={{ marginTop: "15px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                label="วันที่เริ่มต้น"
                                sx={{
                                  "& .MuiInputLabel-root": {
                                    position: "absolute",
                                    top: "-17px",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.12)",
                                    padding: "0 4px",
                                  },
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "background.paper",
                                    border: "1px solid black",
                                    height: "40px",
                                    width: "137px",
                                    paddingBottom: "3px",
                                    fontSize: "14px",
                                    color: "#0077B6",
                                  },
                                }}
                                value={start_date !== "" ? start_date : null}
                                onChange={(newValue) => setStart_date(newValue)}
                              />
                              <DatePicker
                                label="วันที่สิ้นสุด"
                                sx={{
                                  "& .MuiInputLabel-root": {
                                    position: "absolute",
                                    top: "-17px",
                                    left: "13px",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.12)",
                                    padding: "0 4px",
                                  },
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "background.paper",
                                    border: "1px solid black",
                                    height: "40px",
                                    width: "137px",
                                    paddingBottom: "3px",
                                    fontSize: "14px",
                                    color: "#0077B6",
                                    marginLeft: "12px",
                                  },
                                }}
                                value={end_date !== "" ? end_date : null}
                                onChange={(newValue) => setEnd_date(newValue)}
                              />
                              <Button
                                variant="warning"
                                style={{
                                  marginLeft: "10px",
                                  fontSize: "14px",
                                  width: "50px",
                                  height: "25px",
                                  padding: "2.5px 10px 10px 10px",
                                }}
                                onClick={() => {
                                  getDate_Time("today");
                                }}
                              >
                                วันนี้
                              </Button>
                            </LocalizationProvider>
                          </div>
                          <div style={{ marginTop: "15px" }}>
                            <h5>ช่วงเวลาในแต่ละวันที่ต้องการสำรวจ</h5>
                          </div>

                          <div className="selection-Time">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <TimePicker
                                label="เวลาเริ่มต้น"
                                sx={{
                                  "& .MuiInputLabel-root": {
                                    position: "absolute",
                                    top: "-17px",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.12)",
                                    padding: "0 4px",
                                  },
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "background.paper",
                                    border: "1px solid black",
                                    height: "40px",
                                    width: "137px",
                                    paddingBottom: "3px",
                                    fontSize: "14px",
                                    color: "#0077B6",
                                  },
                                }} //style MUI
                                value={start_time !== "" ? start_time : null}
                                onChange={(newValue) => setStart_time(newValue)}
                              />
                              <TimePicker
                                label="เวลาสิ้นสุด"
                                sx={{
                                  "& .MuiInputLabel-root": {
                                    position: "absolute",
                                    top: "-17px",
                                    left: "13px",
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.12)",
                                    padding: "0 4px",
                                  },
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "background.paper",
                                    border: "1px solid black",
                                    height: "40px",
                                    width: "137px",
                                    paddingBottom: "3px",
                                    fontSize: "14px",
                                    color: "#0077B6",
                                    marginLeft: "12px",
                                  },
                                }} //style MUI
                                value={end_time !== "" ? end_time : null}
                                onChange={(newValue) => setEnd_time(newValue)}
                              />
                              <OverlayTrigger
                                key={"right"}
                                placement={"right"}
                                backgroundColor={"white"}
                                overlay={
                                  <Tooltip id={`tooltip-${"right"}`}>
                                    3 ชั่วโมงหลังจากนี้
                                  </Tooltip>
                                }
                              >
                                <Button
                                  variant="warning"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "14px",
                                    width: "50px",
                                    height: "25px",
                                    padding: "2.5px 10px 10px 10px",
                                  }}
                                  onClick={() => {
                                    getDate_Time("3Hours");
                                  }}
                                >
                                  <p>3 H</p>
                                </Button>
                              </OverlayTrigger>
                            </LocalizationProvider>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              textAlign: "center",
                              alignItems: "center",
                              marginLeft: "5px",
                            }}
                          >
                            <label style={{ marginRight: "10px" }}>
                              เลือกขอบเขต :{" "}
                            </label>
                            <select
                              style={{
                                height: "25px",
                                marginTop: "5px",
                                borderRadius: "5px",
                              }}
                              onChange={(e) => {
                                setDimensionArea(e.target.value);
                              }}
                            >
                              <option value="1"> 1 km.</option>
                              <option value="2">2 km.</option>
                              <option value="3"> 3 km.</option>
                              <option value="4">4 km.</option>
                              <option value="5"> 5 km.</option>
                              <option value="6">6 km.</option>
                              <option value="7">7 km.</option>
                            </select>
                            <div style={{ marginLeft: "60px" }}>
                              {/* <Button
                          variant="warning"
                          style={{
                            padding: "5px 10px 5px 10px",
                            width: "120px",
                          }}
                          onClick={() => {
                          }}
                        >
                          ตรวจสอบพื้นที่
                        </Button> */}
                            </div>
                          </div>
                          <Row
                            style={{
                              justifyContent: "left",
                              marginTop: "0px",
                              marginLeft: "10px",
                            }}
                          >
                            <Form.Group
                              as={Col}
                              md="7"
                              style={{ padding: "0px" }}
                            >
                              <Form.Check
                                className="check-box"
                                id={`inline-checkbox-1`}
                                type="radio"
                                label="แผนการบินใกล้คุณ"
                                name="radioGroup"
                                defaultChecked={operator_Area_Checked === true}
                                onChange={(e) => {
                                  setOperator_Area_Checked(
                                    !operator_Area_Checked
                                  );
                                }}
                              />
                            </Form.Group>
                            <Form.Group
                              as={Col}
                              md="5"
                              style={{ padding: "0px" }}
                            >
                              <Form.Check
                                //disabled
                                className="check-box"
                                id={"`inline-radio-2`"}
                                type="radio"
                                label="พื้นที่หวงห้าม"
                                name="radioGroup"
                                defaultChecked={operator_Area_Checked === false}
                                onChange={() => {
                                  setOperator_Area_Checked(
                                    !operator_Area_Checked
                                  );
                                }}
                              />
                            </Form.Group>
                          </Row>
                          <div
                            style={{
                              display: "flex",
                              textAlign: "center",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "5px",
                              marginTop: "5px",
                            }}
                          >
                            <span
                              className="tabplan"
                              style={{
                                color: "red",
                                fontWeight: "500",
                                fontSize: "14px",
                              }}
                            >
                              *** คลิกขวาบนแผนที่เพื่อเลือกพื้นที่ ***
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Offcanvas.Body>

                  {operator_Area_Checked === true ? (
                    <>
                      <Offcanvas.Body>
                        <div className="sidebar-wrapper">
                          <div className="sidebar-card">
                            <div
                              className="sidebar-card-body"
                              style={{ maxHeight: "190px" }}
                            >
                              <h5>พื้นที่ปฏิบัติการของฉัน</h5>
                              {operator_Area_Checked === true ? (
                                intersection_Near_Plan !== undefined ? (
                                  intersection_Near_Plan.features.map(
                                    (feature, index) => {
                                      if (
                                        feature.properties
                                          .operation_operator === userName
                                      ) {
                                        return (
                                          <p
                                            key={index}
                                            tabIndex={0}
                                            className="datafeatures"
                                            onClick={() => {
                                              MoveToCenterPolygon(feature);
                                            }}
                                          >
                                            หมายเลขปฏิบัติการ:{" "}
                                            {feature.properties.operation_id}
                                          </p>
                                        );
                                      }
                                      // else {
                                      //   return (
                                      //     <p
                                      //       style={{
                                      //         color: "red",
                                      //         textAlign: "center",
                                      //       }}
                                      //     >
                                      //       *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด
                                      //       ***
                                      //     </p>
                                      //   );
                                      // }
                                    }
                                  )
                                ) : (
                                  <p
                                    style={{
                                      color: "red",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด ***
                                  </p>
                                )
                              ) : intersection_All.length !== 0 ? (
                                intersection_All.map((feature) => {
                                  return (
                                    <p
                                      tabIndex={0}
                                      className="datafeatures"
                                      onClick={() => {
                                        MoveToCenterPolygon(feature);
                                        setShowRemarks(() => ({
                                          ShowRemarkNearPlan: true,
                                          DataFocus: feature.properties.name,
                                        }));
                                        setRemarkData({
                                          remarks: feature.properties.remarks,
                                          upperLimit:
                                            feature.properties.upper_limit,
                                          lowerLimit:
                                            feature.properties.lower_limit,
                                        });
                                      }}
                                    >
                                      {feature.properties.name !== undefined ? (
                                        <>- {feature.properties.name}</>
                                      ) : feature.properties.Agency !==
                                        undefined ? (
                                        <>- {feature.properties.Agency}</>
                                      ) : (
                                        <>- ไม่ทราบชื่อของข้อมูล</>
                                      )}
                                    </p>
                                  );
                                })
                              ) : (
                                <p
                                  style={{ color: "red", textAlign: "center" }}
                                >
                                  {" "}
                                  *** ไม่พบข้อมูล พื้นที่ห้ามบิน***
                                </p>
                              )}
                            </div>
                          </div>
                          {showRemarks.ShowRemarkNearPlan === true ? (
                            <RemarkDetails
                              data={remarkData}
                              datatype={"remarkdata"}
                            />
                          ) : null}
                        </div>
                      </Offcanvas.Body>
                      <Offcanvas.Body>
                        <div className="sidebar-wrapper">
                          <div className="sidebar-card">
                            <div
                              className="sidebar-card-body"
                              style={{ maxHeight: "190px" }}
                            >
                              <h5>พื้นที่ปฏิบัติการของผู้อื่น</h5>
                              {operator_Area_Checked === true ? (
                                intersection_Near_Plan !== undefined ? (
                                  intersection_Near_Plan.features.map(
                                    (feature, index) => {
                                      if (
                                        feature.properties
                                          .operation_operator !== userName
                                      ) {
                                        return (
                                          <p
                                            key={index}
                                            tabIndex={0}
                                            className="datafeatures"
                                            onClick={() => {
                                              MoveToCenterPolygon(feature);
                                            }}
                                          >
                                            หมายเลขปฏิบัติการ:{" "}
                                            {feature.properties.operation_id}
                                          </p>
                                        );
                                      }
                                      // else {
                                      //   return (
                                      //     <p
                                      //       style={{
                                      //         color: "red",
                                      //         textAlign: "center",
                                      //       }}
                                      //     >
                                      //       *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด
                                      //       ***
                                      //     </p>
                                      //   );
                                      // }
                                    }
                                  )
                                ) : (
                                  <p
                                    style={{
                                      color: "red",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด ***
                                  </p>
                                )
                              ) : intersection_All.length !== 0 ? (
                                intersection_All.map((feature) => {
                                  return (
                                    <p
                                      tabIndex={0}
                                      className="datafeatures"
                                      onClick={() => {
                                        MoveToCenterPolygon(feature);
                                        setShowRemarks(() => ({
                                          ShowRemarkNearPlan: true,
                                          DataFocus: feature.properties.name,
                                        }));
                                        setRemarkData({
                                          remarks: feature.properties.remarks,
                                          upperLimit:
                                            feature.properties.upper_limit,
                                          lowerLimit:
                                            feature.properties.lower_limit,
                                        });
                                      }}
                                    >
                                      {feature.properties.name !== undefined ? (
                                        <>- {feature.properties.name}</>
                                      ) : feature.properties.Agency !==
                                        undefined ? (
                                        <>- {feature.properties.Agency}</>
                                      ) : (
                                        <>- ไม่ทราบชื่อของข้อมูล</>
                                      )}
                                    </p>
                                  );
                                })
                              ) : (
                                <p
                                  style={{ color: "red", textAlign: "center" }}
                                >
                                  {" "}
                                  *** ไม่พบข้อมูล พื้นที่ห้ามบิน***
                                </p>
                              )}
                            </div>
                          </div>
                          {showRemarks.ShowRemarkNearPlan === true ? (
                            <RemarkDetails
                              data={remarkData}
                              datatype={"remarkdata"}
                            />
                          ) : null}
                        </div>
                      </Offcanvas.Body>
                    </>
                  ) : (
                    <Offcanvas.Body>
                      <div className="sidebar-wrapper">
                        <div className="sidebar-card">
                          <div
                            className="sidebar-card-body"
                            style={{ maxHeight: "190px" }}
                          >
                            <h5>พื้นที่หวงห้าม</h5>
                            {operator_Area_Checked === true ? (
                              intersection_Near_Plan !== undefined ? (
                                intersection_Near_Plan.features.map(
                                  (feature, index) => {
                                    if (
                                      feature.properties.operation_operator !==
                                      userName
                                    ) {
                                      return (
                                        <p
                                          key={index}
                                          tabIndex={0}
                                          className="datafeatures"
                                          onClick={() => {
                                            MoveToCenterPolygon(feature);
                                          }}
                                        >
                                          หมายเลขปฏิบัติการ:{" "}
                                          {feature.properties.operation_id}
                                        </p>
                                      );
                                    }
                                    // else {
                                    //   return (
                                    //     <p
                                    //       style={{
                                    //         color: "red",
                                    //         textAlign: "center",
                                    //       }}
                                    //     >
                                    //       *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด
                                    //       ***
                                    //     </p>
                                    //   );
                                    // }
                                  }
                                )
                              ) : (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  *** ไม่พบข้อมูล ในช่วงเวลาที่คุณกำหนด ***
                                </p>
                              )
                            ) : intersection_All.length !== 0 ? (
                              intersection_All.map((feature) => {
                                const diplayProhibitNames = () => {
                                  const propertiesOfItem = feature.properties;
                                  if (propertiesOfItem.name) {
                                    return propertiesOfItem.name;
                                  }
                                  if (propertiesOfItem.Agency) {
                                    return propertiesOfItem.Agency;
                                  }
                                  if (propertiesOfItem.name_t) {
                                    return propertiesOfItem.name_t;
                                  }
                                  return "ไม่พบข้อมูล";
                                };
                                return (
                                  <p
                                    tabIndex={0}
                                    className="datafeatures"
                                    onClick={() => {
                                      MoveToCenterPolygon(feature);
                                      setShowRemarks(() => ({
                                        ShowRemarkNearPlan: true,
                                        DataFocus: feature.properties.name,
                                      }));
                                      setRemarkData({
                                        remarks: feature.properties.remarks,
                                        upperLimit:
                                          feature.properties.upper_limit,
                                        lowerLimit:
                                          feature.properties.lower_limit,
                                      });
                                    }}
                                  >
                                    {diplayProhibitNames()}
                                    {/* {feature.properties.name !== undefined ? (
                                      <>- {feature.properties.name}</>
                                    ) : feature.properties.Agency !==
                                      undefined ? (
                                      <>- {feature.properties.Agency}</>
                                    ) : (
                                      <>- ไม่ทราบชื่อของข้อมูล</>
                                    )} */}
                                  </p>
                                );
                              })
                            ) : (
                              <p style={{ color: "red", textAlign: "center" }}>
                                {" "}
                                *** ไม่พบข้อมูล พื้นที่ห้ามบิน***
                              </p>
                            )}
                          </div>
                        </div>
                        {showRemarks.ShowRemarkNearPlan === true ? (
                          <RemarkDetails
                            data={remarkData}
                            datatype={"remarkdata"}
                          />
                        ) : null}
                      </div>
                    </Offcanvas.Body>
                  )}
                </Tab>
                <Tab
                  eventKey="2"
                  title={
                    <span
                      className="tabplan"
                      style={{
                        color: "#0077B6",
                        fontWeight: "500",
                      }}
                    >
                      อื่นๆ
                    </span>
                  }
                >
                  <Offcanvas.Body>
                    <div className="sidebar-wrapper">
                      <div className="sidebar-card">
                        <div className="sidebar-card-title">
                          <h6>พื้นที่อื่นๆ</h6>
                        </div>
                        <div
                          className="sidebar-card-body"
                          style={{ maxHeight: "220px" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyItems: "space-between",
                              padding: "10px",
                            }}
                          >
                            <div>
                              <Button
                                variant="danger"
                                onClick={() => {
                                  handleShow();
                                }}
                              >
                                ตรวจสอบพื้นที่ห้ามบินทั้งหมด
                              </Button>
                            </div>
                            <div>-</div>
                            <div>
                              <Button
                                variant="danger"
                                onClick={() => {
                                  setForeCast_Active(!forecast_active);
                                }}
                              >
                                สภาพอากาศ
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Offcanvas.Body>
                </Tab>
              </Tabs>
              <OverlayTrigger
                key={"right"}
                placement={"right"}
                overlay={<Tooltip id={`tooltip-${"right"}`}>Close</Tooltip>}
              >
                <div
                  className="toNavSide-btn icon-pointer"
                  style={{
                    top: "50%",
                    borderRadius: "0px 10px 10px 0px",
                    animation: "none",
                  }}
                  onClick={() => {
                    setSidebarMain(!sidebarMain);
                  }}
                >
                  <MdDoubleArrow />
                </div>
              </OverlayTrigger>
            </div>
          </>
        ) : (
          <div
            className="sidebar-main"
            style={{
              position: "relative",
              top: "0px",
              height: "auto",
              width: "1%",
              animation: "none",
            }}
          >
            <OverlayTrigger
              key={"left"}
              placement={"left"}
              overlay={<Tooltip id={`tooltip-${"left"}`}>Open</Tooltip>}
            >
              <div
                className="toNavSide-btn icon-pointer"
                style={{
                  top: "50%",
                  borderRadius: "10px 0px 0px 10px",
                  right: "0px",
                  animation: "none",
                }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <MdDoubleArrow style={{ transform: "scaleX(-1)" }} />
              </div>
            </OverlayTrigger>
            {/* <OverlayTrigger
              key={"left"}
              placement={"left"}
              overlay={<Tooltip id={`tooltip-${"left"}`}>Close</Tooltip>}
            >
              <div
                className="toNavSide-btn icon-pointer"
                style={{ top: "50%", borderRadius: "0px 10px 10px 0px", animation:"none" }}
                onClick={() => {
                  setSidebarMain(!sidebarMain);
                }}
              >
                <MdDoubleArrow />
              </div>
            </OverlayTrigger> */}
          </div>
        )}
      </div>

      {/* scrollTo */}
      {/* {scrollPosition === 0 ? (
        <>
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={<Tooltip id={`tooltip-${"top"}`}>to bottom</Tooltip>}
          >
            <div
              className="toNav-btn icon-pointer"
              style={{ bottom: "0px", borderRadius: "10px 10px 0px 0px" }}
              onClick={() => {
                window.scrollTo(0, 100);
              }}
            >
              <MdOutlineKeyboardDoubleArrowUp
                style={{ transform: "scaleY(-1)" }}
              />
            </div>
          </OverlayTrigger>
        </>
      ) : (
        <>
          <OverlayTrigger
            key={"bottom"}
            placement={"bottom"}
            overlay={<Tooltip id={`tooltip-${"bottom"}`}>to above</Tooltip>}
          >
            <div
              className="toNav-btn icon-pointer"
              style={{ top: "84.5px", borderRadius: "0px 0px 10px 10px" }}
              onClick={() => {
                window.scrollTo(0, 0);
              }}
            >
              <MdOutlineKeyboardDoubleArrowUp />
            </div>
          </OverlayTrigger>
        </>
      )} */}

      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      {/* Sidebar Main */}
      {/* Sidebar ProhibitArea*/}
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header className="sidebar-header" closeButton>
          <Offcanvas.Title>
            <h3 style={{ marginTop: "15px" }}> ตรวจสอบพื้นที่ห้ามบิน</h3>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <div className="sidebar-section">
          <Offcanvas.Body className="sidebar-wrapper">
            <div className="sidebar-wrapper">
              <div className="sidebar-card">
                <div className="sidebar-card-title">
                  <a className="btn-more">
                    <i
                      className="dash-more"
                      onClick={() => {
                        setIconEye1(!iconeye1);
                      }}
                    >
                      {iconeye1 === true ? (
                        <FaRegEye size={25} />
                      ) : (
                        <FaRegEyeSlash size={27} />
                      )}
                    </i>
                  </a>
                  <h5>พื้นที่หวงห้ามเด็ดขาด </h5>
                </div>

                <div
                  className="sidebar-card-body"
                  style={{ maxHeight: "150px" }}
                >
                  {PDRArea !== undefined
                    ? PDRArea.features.map((feature) => {
                        return (
                          <>
                            {feature.properties.name
                              .split(" ")
                              .join("")
                              .slice(0, 3) === "VTP" ? (
                              <p
                                tabIndex={0}
                                className="datafeatures"
                                onClick={() => {
                                  setShowRemarks(() => ({
                                    ShowRemark1: true,
                                    DataFocus: feature.properties.name,
                                  }));
                                  setRemarkData({
                                    remarks: feature.properties.remarks,
                                    upperLimit: feature.properties.upper_limit,
                                    lowerLimit: feature.properties.lower_limit,
                                  });
                                  MoveToCenterPolygon(feature);
                                }}
                              >
                                - {feature.properties.name}
                              </p>
                            ) : null}
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
          {/* Show Remarks */}
          {showRemarks.ShowRemark1 === true ? (
            <RemarkDetails data={remarkData} datatype={"remarkdata"} />
          ) : null}
        </div>
        <div className="sidebar-section">
          <Offcanvas.Body className="sidebar-wrapper">
            <div className="sidebar-wrapper">
              <div className="sidebar-card">
                <div className="sidebar-card-title">
                  <a className="btn-more">
                    <i
                      className="dash-more"
                      onClick={() => {
                        setIconEye2(!iconeye2);
                      }}
                    >
                      {iconeye2 === true ? (
                        <FaRegEye size={25} />
                      ) : (
                        <FaRegEyeSlash size={27} />
                      )}
                    </i>
                  </a>
                  <h5>พื้นที่หวงห้ามเฉพาะ </h5>
                </div>
                <div
                  className="sidebar-card-body"
                  style={{ maxHeight: "150px" }}
                >
                  {PDRArea !== undefined
                    ? PDRArea.features.map((feature) => {
                        return (
                          <>
                            {feature.properties.name
                              .split(" ")
                              .join("")
                              .slice(0, 3) === "VTR" ? (
                              <p
                                tabIndex={0}
                                className="datafeatures"
                                onClick={() => {
                                  setShowRemarks(() => ({
                                    ShowRemark2: true,
                                    DataFocus: feature.properties.name,
                                  }));
                                  setRemarkData({
                                    remarks: feature.properties.remarks,
                                    upperLimit: feature.properties.upper_limit,
                                    lowerLimit: feature.properties.lower_limit,
                                  });
                                  MoveToCenterPolygon(feature);
                                }}
                              >
                                - {feature.properties.name}
                              </p>
                            ) : null}
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
          {/* Show Remarks */}
          {showRemarks.ShowRemark2 === true ? (
            <RemarkDetails data={remarkData} datatype={"remarkdata"} />
          ) : null}
        </div>
        <div className="sidebar-section">
          <Offcanvas.Body className="sidebar-wrapper">
            <div className="sidebar-wrapper">
              <div className="sidebar-card">
                <div className="sidebar-card-title">
                  <a className="btn-more">
                    <i
                      className="dash-more"
                      onClick={() => {
                        setIconEye3(!iconeye3);
                      }}
                    >
                      {iconeye3 === true ? (
                        <FaRegEye size={25} />
                      ) : (
                        <FaRegEyeSlash size={27} />
                      )}
                    </i>
                  </a>
                  <h5>พื้นที่อันตราย </h5>
                </div>
                <div
                  className="sidebar-card-body"
                  style={{ maxHeight: "150px" }}
                >
                  {PDRArea !== undefined
                    ? PDRArea.features.map((feature) => {
                        return (
                          <>
                            {feature.properties.name
                              .split(" ")
                              .join("")
                              .slice(0, 3) === "VTD" ? (
                              <p
                                tabIndex={0}
                                className="datafeatures"
                                onClick={() => {
                                  setShowRemarks(() => ({
                                    ShowRemark3: true,
                                    DataFocus: feature.properties.name,
                                  }));
                                  setRemarkData({
                                    remarks: feature.properties.remarks,
                                    upperLimit: feature.properties.upper_limit,
                                    lowerLimit: feature.properties.lower_limit,
                                  });
                                  MoveToCenterPolygon(feature);
                                }}
                              >
                                - {feature.properties.name}
                              </p>
                            ) : null}
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
          {/* Show Remarks */}
          {showRemarks.ShowRemark3 === true ? (
            <RemarkDetails
              data={remarkData}
              dataFocus={remarkData.dataFocus}
              datatype={"remarkdata"}
              top={"550px"}
            />
          ) : null}
        </div>
      </Offcanvas>
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            กรุณาขึ้นทะเบียนผู้ฎิบัติการก่อนค่ะ
          </div>
        </Modal.Body>
      </Modal>
      {/* รอบล็อค */}
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ท่านยังไม่ได้ขึ้นทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default OperationDisplays;
